.product-selector-link {
  cursor: pointer;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: #42b4e6;
  padding-top: 0;
  margin-top: 15px;
}

:host(:not([dir="rtl"])) .product-selector-link {
  padding-left: 75px;
}

:host([dir="rtl"]) .product-selector-link {
  padding-right: 75px;
}

.product-selector-link pes-icon {
  position: relative;
}

.product-selector-link pes-icon:hover {
  text-decoration: none;
}

@media screen and (min-width: 980px) {
  .product-selector-link pes-icon {
    text-decoration: none;
  }
}

@media screen and (min-width: 980px) {
  .product-selector-link {
    margin-top: 10px;
  }

  :host(:not([dir="rtl"])) .product-selector-link {
    padding-left: 0;
    margin-left: 0;
  }

  :host([dir="rtl"]) .product-selector-link {
    padding-right: 0;
    margin-right: 0;
  }
}

.product-selector-btn {
  box-sizing: border-box;
  width: 100%;
  margin-top: 16px;
  background-color: #42b4e6;
  border: none;
  padding: 10px 20px;
  color: #ffffff;
  font-size: 16px;
  line-height: 20px;
  outline: none;
  cursor: pointer;
  font-weight: 400;
}

.product-selector-btn *,
.product-selector-btn *::before,
.product-selector-btn *::after {
  box-sizing: inherit;
}

:host(:not([dir="rtl"])) .product-selector-btn:hover {
  background: linear-gradient(180deg, #55d1fe, #42b4e6);
}

:host([dir="rtl"]) .product-selector-btn:hover {
  background: linear-gradient(-180deg, #55d1fe, #42b4e6);
}

.product-selector-btn:active {
  background: #3a738c;
}

@media screen and (min-width: 980px) {
  .product-selector-btn {
    width: auto;
  }
}

:host(:not([dir="rtl"]).sub) .product-selector-link {
  padding-left: 0;
}

:host([dir="rtl"].sub) .product-selector-link {
  padding-right: 0;
}